export const TRANSACTION_LOADING = "TRANSACTION_LOADING";
export const TRANSACTION_ERROR = "TRANSACTION_ERROR";
export const TRANSACTION_SUCCESS = "TRANSACTION_SUCCESS";